import { z } from 'zod';
/** UUID v4 (or any RFC 4122 form). */
export const UuidSchema = z.string().uuid();
/** ISO 8601 datetime with timezone. */
export const IsoDateSchema = z.string().datetime({ offset: true });
/** Integer cents — money is always int, never float. */
export const CentsSchema = z.number().int();
/** Auth scope for an endpoint — sdk-tenant/sdk-rbac choose middleware from this. */
export const AUTH_SCOPES = ['public', 'tenant', 'service', 'manager', 'owner'];
/** ISO 4217 currency code (we only validate common ones; extend as needed). */
export const CurrencySchema = z.enum(['MXN', 'USD']);
//# sourceMappingURL=primitives.js.map